import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Link } from 'react-router-dom';

import { rem, themed } from '@/shared/ui/core';

const modifiers = {
  vaccine: ({ theme }) => ({
    styles: `
     .ShiftTypeIntro {
       background-color: ${theme.primary.yellow};
     }
    `,
  }),
  limitedHospital: ({ theme }) => ({
    styles: `
     .ShiftTypeIntro {
       background-color: ${theme.primary.lightGreen};
     }
    `,
  }),
  fullHospital: ({ theme }) => ({
    styles: `
     .ShiftTypeIntro {
       background-color: ${theme.primary.pink}50;
     }
    `,
  }),
};

export const ShiftTypeStyled = styled.div.attrs({
  className: 'ShiftTypeStyled',
})`
  padding: 0.5rem;
  ${applyStyleModifiers(modifiers)};
`;

export const ShiftTypeIntro = styled.div.attrs({
  className: 'ShiftTypeIntro',
})`
  padding: 1rem;
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .Title {
    font-size: 1.25rem;
    text-align: center;
    color: ${themed('primary.main')};
    margin: 0.35rem 0 0.25rem;
  }

  .Text {
    text-align: center;
    max-width: 14rem;
    margin-bottom: 0;
  }
`;

export const IconWrapper = styled.div.attrs({
  className: 'IconWrapper',
})`
  width: 4rem;
  height: 4rem;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
`;

export const ShiftDetails = styled.div.attrs({
  className: 'ShiftDetails',
})`
  margin-top: 1.35rem;

  .Title {
    font-size: 0.875rem;
    line-height: 1.5;
    margin-bottom: 0.125rem;
    color: ${themed('primary.main')};
  }

  .Text {
    font-size: 0.875rem;
    line-height: 1.2;
    margin-bottom: 0;
  }
`;

export const DescriptionList = styled.ul.attrs({
  className: 'DescriptionList',
})`
  padding: 0;
  padding-left: 1rem;
  margin: 0;
  margin-top: 0.5rem;
  width: 100%;
  margin-bottom: 1em;
`;

export const DescriptionItem = styled.li.attrs({
  className: 'DescriptionItem',
})`
  padding: 0;
  margin: 0;
  list-style: disc;
  margin-bottom: 0.25rem;
  width: 100%;
  position: relative;

  .Text {
    margin-bottom: 0;
    font-size: 0.875rem;
    width: 100%;
  }
`;

export const DetailsLink = styled(Link)`
  color: ${themed('primary.text')};
  display: block;
  font-size: ${rem(14)};
  margin-bottom: 1rem;
`;
